import { inject, Injectable } from '@angular/core';
import { HasAccessRightPipe } from '../pipes/has-access-right/hasAccessRight.pipe';
import { EUserRight } from '@web/dtos';
import { CanActivate } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class UserIsAdminGuard implements CanActivate {
  private readonly hasAccessRight: HasAccessRightPipe =
    inject(HasAccessRightPipe);
  canActivate(): boolean {
    return this.hasAccessRight.transform(EUserRight.CmsAdmin);
  }
}
